import { literal, preprocess } from 'zod';

import { requiresActivationConstraintWithLimitsSchema } from '@occc/feat-constraints/schemas';

import { BaseEligibleEarnSchema } from './base-eligible-earn.schema';

import { AwardCountWithoutTransactionSchema } from '../award-count.schema';
import { AwardPointsPerVariantSchema } from '../award.schema';
import { BaseOfferConfigurationSchema } from '../base-offer.schema';
import { OfferType } from '../../types';

export const BaseEligibleEarnOfferSchema = BaseOfferConfigurationSchema.extend({
  offerType: literal(OfferType.BaseEligibleEarn),
  baseEligibleEarn: preprocess((data) => data ?? {}, BaseEligibleEarnSchema),
  awardCount: AwardCountWithoutTransactionSchema,
  activation: requiresActivationConstraintWithLimitsSchema,
}).merge(AwardPointsPerVariantSchema);
